import { useNavigate } from 'react-router-dom'

export default function RouterHook() {
  const navigate = useNavigate()

  const serverRouter = (rota, query) => {
    /* -- Como é as rotas no router
      const rotas_label = {
        login: '/',
        static: '/static',
        register: '/cadastro',
        aspectLegal: '/aspectos-legais/:idusuario',
        home: '/cidade/:cidadeLabel',
        homeChat: '/conversas/:idusuario',
        homeCompany: '/centro-esportivo/:username',
        detailsApp: '/agendamento/:idpedido',
        settings: '/configuracoes/:idusuario', 
        userSched: '/minha-agenda',
        erro404: '*',
      }
    */
    switch (rota) {
      case 'back':
        return navigate(-1)

      case 'login':
        return navigate(`/`)

      case 'cadastro':
        return navigate(`/cadastro`)

      case 'home':
        return navigate(`/cidade/${query}`)

      case 'centro-esportivo':
        return navigate(`/centro-esportivo/${query}`)

      case 'settings':
        return navigate(`/configuracoes/${query}`)

      case 'agendamento':
        return navigate(`/agendamento/${query}`)

      case 'minha-agenda':
        return navigate(`/minha-agenda`)

      case 'chat':
        return navigate(`/conversas/${query}`)

      case 'mensalista':
        return navigate(`/mensalista/${query}`)

      case 'diaria':
        return navigate(`/diaria/${query}`)

      case 'pay-pix':
        return navigate(`/pagamento/${query}`)

      case 'aspectLegal':
        return navigate(`/aspectos-legais/${query}`)

      case 'torneio':
        return navigate(`/competicao/${query}`)

      default:
        return navigate(`/`)
    }
  }

  return serverRouter
}
